import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { t } from "i18next";
import WithMap from "components/Hoc/WithMap";
import { useMapContext } from "contexts/googleMap";
import useConfirmGeoLocation from "service-hooks/useConfirmGeoLocation";
import { CustomButton } from "components/Button";
import { CustomModal, ErrorModal } from "components";

const LocationPicker = ({locationInfo, setLocationInfo=() => {}}) => {
  const [mapref, setMapRef] = useState(null);
  const [radius, setRadius] = useState(1000);
  const { confirmGeoLocation } = useConfirmGeoLocation();
  const { googlemapState, setZoom,  setMapAddress, setUserLocation } = useMapContext();

  const { zoom } = useSelector((state) => state.DeliveryAddressReducer);
  const [zoomErrorModal, setZoomErrorModal] = useState({
    open: false,
    message: "",
  });

  const handleConfirmLocation = async () => {
    const res = await confirmGeoLocation();
    if (res?.isValid) {;
      setLocationInfo({...res, radius});
    } else {
      setZoomErrorModal({
        open: true,
        message: res.message,
      });
    }
  };


  useEffect(() => {
    if (locationInfo) {
      setMapAddress(locationInfo?.mapAddress);
      setUserLocation(locationInfo?.userLocation);
      setZoom(locationInfo?.zoom);
    }
    setRadius(locationInfo?.radius || 10);
  }, [locationInfo]);

  return (
    <>
      {" "}
      <style>
        {`
        .container-height {
          height: 600px;
        }
          .map-container-height {
            height:400px;
          }
        `}
      </style>
      <div className="w-full h-full flex flex-col gap-2 relative container-height">
        <div className="flex-1">
          <WithMap
            class={"map-container-height"}
            width="100%"
            height="100%"
            showInput={true}
            zoomChanging={true}
            zoom={zoom}
            setMapRef={setMapRef}
            mapref={mapref}
            googlemapState={{
              userLocation: {
                lat: googlemapState?.userLocation?.coordinates?.lat,
                lng: googlemapState?.userLocation?.coordinates?.lng,
              },
              zoom: googlemapState?.zoom,
              mapAddress: googlemapState?.mapAddress,
            }}
            zoomerror={zoomErrorModal?.message?.msg}
            isZoomModalOpen={zoomErrorModal?.open}
            setZoomErrorModal={() =>
              setZoomErrorModal({ open: false, message: "" })
            }
          />
        </div>
        <div className="sticky bottom-0 z-10 bg-white/30 backdrop-blur-md">
          <div className="flex flex-col gap-2">
         
         <div className="flex-1 flex gap-2 items-center py-2">
          <label className="text-16x font-bold">{t("Radius In KM")} : </label>
          <input type="number" name="radius" value={radius} onChange={(e) => setRadius(e.target.value)} defaultValue={10} min={1} className="flex-1 w-full border border-gray-300 rounded-md p-2 rounded-16x" />
         </div>
         <CustomButton onClick={handleConfirmLocation}>
            Confirm Location
          </CustomButton>
          </div>
        </div>
        <CustomModal
          open={zoomErrorModal?.open}
          setOpen={() => setZoomErrorModal({ open: false, message: "" })}
          bodyclasses="flex"
          overlayClasses="fixed h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-50"
        >
          <ErrorModal
            handleClik={() => {
              setZoom(16);
              setZoomErrorModal({ open: false, message: "" });
            }}
            message={zoomErrorModal?.message?.msg}
            btnTitle={
              zoomErrorModal?.message?.type === "zoom"
                ? t("Increase zoom")
                : null
            }
          />
        </CustomModal>
      </div>
    </>
  );
};

export default LocationPicker;
